export default __webpack_public_path__ + "static/media/013-drone.81263fc4.svg";